export const GET_DICTIONARY_COMPANIES = Symbol('GET_DICTIONARY_COMPANIES');
export const GET_DICTIONARY_COMPANIES_REQUEST = Symbol('GET_DICTIONARY_COMPANIES_REQUEST');
export const GET_DICTIONARY_COMPANIES_SUCCESS = Symbol('GET_DICTIONARY_COMPANIES_SUCCESS');
export const GET_DICTIONARY_COMPANIES_ERROR = Symbol('GET_DICTIONARY_COMPANIES_ERROR');

